import React, { useState, useEffect, Fragment } from 'react';
import { Row, Collapse, Button, Card, CardBody } from 'reactstrap';
import CopyToClipboard from "react-copy-to-clipboard";
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import '../components/css/property.scss';
// import MessageResponse from './components/ResponseBlock/MessageResponse';
// import LinkResponse from './components/ResponseBlock/LinkResponse';
// import ImageCarouselResponse from './components/ResponseBlock/ImageCarouselResponse';
import { RotateSpinner } from 'react-spinners-kit';
import ExampleResponse from '../components/ResponseBlock/ExampleResponse';
import {
    API_OpenAI_Assistant,
    gAPI_QuestionSets,
    gAPI_FormsBy_PropertyId,
    gAPI_Search_Business,
    gAPI_Room_CategoryTags,
    postAPI_Update_QuestionSet_DisplayOrder,
    postAPI_Update_Question_DisplayOrder,
    gAPI_Internal_Property_By_Id
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import QuestionSetForm from './components/QuestionSetForm';
import Question from './components/Question';
import QuestionSet from './components/QuestionSet';
import { faPlus, faBan, faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import short from 'short-uuid';
import ReactDragListView from "react-drag-listview";
import { List, Typography } from "antd";
import Business_Operator_Recommender from './../../../../../assets/business_operator_recommender.png';
import All_Recommender from './../../../../../assets/all_recommender.png';
import "antd/dist/antd.css";

function Index({ propertyId, locale, domains, userName }) {
    const [assistantId, setAssistantId] = useState();
    const [responseData, setResponseData] = useState(null);
    const [isAddQuestionSet, setIsAddQuestionSet] = useState(false);
    const [assiCopy, setAssCopy] = useState(false);
    const [result, setResult] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [collapseSet, setCollaspSet] = useState(-1);
    const [quesionSetsList, setQuestionSetsList] = useState([]);
    const [roomTags, setRoomTags] = useState([]);
    const [productTags, setProductTags] = useState([]);
    const [formList, setFormList] = useState([]);
    const [property, setProperty] = useState();
    const setCollasp = (e) => {
        if (collapseSet === e) {
            setCollaspSet(-1);
        }
        else {
            setCollaspSet(e);
        }
    };

    const loadResponse = async () => {
        setIsLoading(true);
        return await AxiosAPI({
            methed: 'get',
            url: `${gAPI_QuestionSets}/?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${locale}`,
        })
            .then(res => {
                var setslist = res.data.sets.sort((a, b) => a.displayOrder - b.displayOrder)
                var list = [];
                if (setslist !== null && setslist.length > 0) {
                    setslist.map(l => {
                        list.push({ id: l.id, name: l.name });
                    })
                }
                setQuestionSetsList(list);
                setResult(setslist);
                setIsLoading(false);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const LoadProduct = () => {
        AxiosAPI({
            methed: 'get',
            url: `${gAPI_Search_Business}/?propertyId=${propertyId}`,
        })
            .then(res => {
                var list = [];
                res.data.map(l => { list.push({ label: l.categories, value: l.categories }) });
                setProductTags(list);
            })
            .catch(err => {
                console.log(err);
            });
    }

    const LoadForm = () => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_FormsBy_PropertyId}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${locale}`,
        })
            .then((res) => {
                setFormList(res.data);
            })
            .catch((err) => console.error(err));
    }

    const LoadRoom = () => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Room_CategoryTags}/${propertyId}`,
        })
            .then(res => {
                console.log(res);
                var list = [];
                res.data.map(l => { list.push({ label: l.categonries, value: l.categories }) });
                setRoomTags(list);
            })
            .catch(err => {
                console.log(err);
            });
    }

    useEffect(() => {
        loadResponse();
        LoadProduct();
        LoadForm();
        LoadRoom();
        AxiosAPI({
            methed: 'get',
            url: `${API_OpenAI_Assistant}/property/get/${propertyId}?group_id=${getGroupID()}`,
        })
            .then(res => {
                if (res.data.status !== undefined && res.data.status !== null && res.data.status !== '')
                    setAssistantId(res.data.status);
            })
            .catch(err => {
                console.log(err);
            });
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
        }).then((res) => {
            setProperty(res.data);
        });
    }, [propertyId]);

    useEffect(() => {
        setResponseData(result);
    }, [result]);

    const CancelQuestionSet = () => {
        setIsAddQuestionSet(false)
    }

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragEnd = (fromIndex, toIndex, type, index, oIndex) => {
        if (toIndex < 0) return;
        if (type === "LIST-ITEM") {
            const categories = reorder(result, fromIndex, toIndex);
            var data = [];
            categories.map((item, i) => {
                data.push({ id: item.id, displayOrder: i })
            });
            AxiosAPI({
                method: 'post',
                url: `${postAPI_Update_QuestionSet_DisplayOrder}`,
                data: { data: data },
            }).then((res) => {
                return loadResponse();
            }).catch((err) => {
                console.log('err', err);
            });
        }
        else if (type === "QUESTION-LIST-ITEM") {
            var stResult = result[index];
            const categories = reorder(stResult.questions, fromIndex, toIndex);
            var data = [];
            categories.map((item, i) => {
                data.push({ id: item.id, displayOrder: i })
            });
            AxiosAPI({
                method: 'post',
                url: `${postAPI_Update_Question_DisplayOrder}`,
                data: { data: data },
            }).then((res) => {
                return loadResponse();
            }).catch((err) => {
                console.log('err', err);
            });

        }
        // else if (type === "QUESTION-OPTION-LIST-ITEM") {
        //     var stResult = result[index];
        //     console.log(stResult);
        //     const categories = reorder(stResult.questions, fromIndex, toIndex);
        //     var data = [];
        //     categories.map((item, i) => {
        //         data.push({ id: item.id, displayOrder: i })
        //     });
        //     console.log(categories, data);
        //     // AxiosAPI({
        //     //     method: 'post',
        //     //     url: `${postAPI_Update_Question_DisplayOrder}`,
        //     //     data: { data: data },
        //     // }).then((res) => {
        //     //     return loadResponse();
        //     // }).catch((err) => {
        //     //     console.log('err', err);
        //     // });
        // }
        else return new Error("NOT A VALID LIST");
    };


    const handlePublish = () => {
        let instructions = '';
        if (result.filter(f => f.type === 'ConversationFlow' &&
            f.publishConversationFlow !== undefined && f.publishConversationFlow === true &&
            f.name !== undefined && f.name !== '' && f.description !== undefined && f.description !== '').length > 0) {
            instructions = 'Return the intent_id based on the customer question. The intent_id and customer question are pipe separated below: \n';
        }
        if (result !== undefined && result !== null && result.length > 0) {
            result.filter(f => f.type === 'ConversationFlow').map((m) => {
                if (m.publishConversationFlow !== undefined && m.publishConversationFlow === true) {
                    if (m.name !== undefined && m.name !== '' && m.description !== undefined && m.description !== '')
                        console.log(m.name.toLowerCase().replaceAll(' ', '_'));
                    instructions += m.name.toLowerCase().replaceAll(' ', '_') + '|' + m.description + '\n';
                }
            });
        }
        if (instructions !== '') {
            instructions += 'Call function find_intent and pass the intent_id and the confidence score between 1 and 100 based on how confident you are that the intent_id is related to the customer question. If you cannot match any intent_id, still call the function and pass intent_id as none.';
        }
        let body = {
            groupId: getGroupID(),
            name: property.name,
            propertyId: propertyId,
            instructions: instructions,
            model: 'gpt-4o',
            creator: userName
        };
        if (assistantId !== undefined && assistantId !== '') {
            AxiosAPI({
                method: 'put',
                url: `${API_OpenAI_Assistant}/property/update/${assistantId}`,
                data: body,
            }).then(res => {
                window.location.reload();
            }).catch(err => {
                //console.log(err);
            });
        } else {
            AxiosAPI({
                method: 'post',
                url: `${API_OpenAI_Assistant}/property/create`,
                data: body,
            }).then(res => {
                window.location.reload();
            }).catch(err => {
                //console.log(err);
            });
        }
    }
    const generator = () => {
        return (
            <Fragment>
                <Row>
                    <Colxx xs="12" sm="12" md="9" lg="9" className="mb-4">
                        {result !== null && result.length > 0 && (
                            <Fragment>
                                <Row>
                                    <Colxx md="3" className="mb-4">
                                        <div
                                            onClick={() => {
                                                setIsAddQuestionSet(true);
                                            }}
                                        >
                                            {/* <Button
                                                color="secondary"
                                                className="add-button"
                                                size="xs"
                                                
                                            > */}
                                            <Button
                                                color="primary"
                                                outline
                                                className=" ml-2"
                                                size="xs"
                                                style={{ width: '100%' }}
                                            >
                                                <FontAwesomeIcon icon={faPlus} />
                                                <span> </span>
                                                Add Conversation Flow
                                            </Button>

                                        </div>
                                    </Colxx>
                                    {/* <Colxx md="3" className="mb-4 ml-3">
                                        <b>Learn about <a
                                            href="https://help.myma.ai/en/articles/9768124-conversation-flows"
                                            style={{ textDecoration: 'underline' }}
                                            target='_blank'
                                        >
                                            Conversation Flows
                                        </a></b>
                                    </Colxx> */}
                                    {((domains !== undefined && domains != null && typeof (domains) !== 'string' && domains.length > 0) &&
                                        domains.filter((f) => f.type === 'BusinessOperator' ||
                                            f.type === 'UtilityProviders').length > 0) &&
                                        <Colxx md="5" className="mb-4 text-right mr-0 d-flex align-items-center">
                                            {assistantId !== undefined &&
                                                <div className='d-flex align-items-center'>
                                                    <span className='mr-2'>(<b>{assistantId}</b>)</span>
                                                    <CopyToClipboard text={assistantId} onCopy={() => setAssCopy(true)}>
                                                        <FontAwesomeIcon icon={faCopy} className="fa icon mr-2" />
                                                    </CopyToClipboard>
                                                    {assiCopy ? "Copied!" : ""}
                                                </div>
                                            }
                                            <Button
                                                color="primary"
                                                className="ml-2"
                                                onClick={() => {
                                                    handlePublish();
                                                }}
                                                style={{ width: '100px' }}
                                                size="xs"
                                            >
                                                Publish
                                            </Button>
                                        </Colxx>}
                                </Row>
                                <Row>
                                    <Colxx xxs='12'>

                                        <div className='info-set-background theme-color-orange d-flex align-items-center'>
                                            <div className=' p-2'>
                                                <svg fill="#f71d1d" version="1.1" id="Capa_1" viewBox="0 0 123.996 123.996" width="20" height="20">
                                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                                    <g id="SVGRepo_iconCarrier">
                                                        <g>
                                                            <path d="M9.821,118.048h104.4c7.3,0,12-7.7,8.7-14.2l-52.2-92.5c-3.601-7.199-13.9-7.199-17.5,0l-52.2,92.5 C-2.179,110.348,2.521,118.048,9.821,118.048z M70.222,96.548c0,4.8-3.5,8.5-8.5,8.5s-8.5-3.7-8.5-8.5v-0.2c0-4.8,3.5-8.5,8.5-8.5 s8.5,3.7,8.5,8.5V96.548z M57.121,34.048h9.801c2.699,0,4.3,2.3,4,5.2l-4.301,37.6c-0.3,2.7-2.1,4.4-4.6,4.4s-4.3-1.7-4.6-4.4 l-4.301-37.6C52.821,36.348,54.422,34.048,57.121,34.048z"></path>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div className=' col-11 col-xs-11 p-2'>
                                                <span className='text-warning '>Dynamic Conversation flows is an advanced feature that can help you control the conversation flow. Making any changes will have direct impact on how AI continues a conversation. {' '}
                                                    <a
                                                        href="https://help.myma.ai/en/articles/9768124-conversation-flows"
                                                        style={{ textDecoration: 'underline' }}
                                                        target='_blank'
                                                    >
                                                        Learn
                                                    </a> about Conversation Flows and  {' '}
                                                    <a href="https://help.myma.ai/en/"
                                                        style={{ textDecoration: 'underline' }}
                                                        target='_blank'
                                                    > get in touch</a>  {' '} with our support team to make changes.
                                                </span>
                                            </div>
                                        </div>

                                    </Colxx>
                                </Row>
                                <Collapse isOpen={isAddQuestionSet}>
                                    <Colxx xxs="4" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
                                        <QuestionSetForm CancelQuestionSet={CancelQuestionSet}
                                            loadResponse={loadResponse}></QuestionSetForm>
                                    </Colxx>
                                </Collapse>
                            </Fragment>
                        )}

                        {result !== null && result.length === 0 && (
                            <Fragment>
                                <Row>
                                    <Colxx xs="12" sm="4" md="4" lg="4" className="mb-4">
                                    </Colxx>
                                    <Colxx xs="12" sm="4" md="4" lg="4" className="mb-4">
                                        <Card className="mb-5 text-center">
                                            <CardBody>
                                                <Row>
                                                    <Colxx xxs="12" className="mb-4">
                                                        <div
                                                            className="content text-center">
                                                            <img
                                                                src={"https://bmbuiassetsprod.blob.core.windows.net/images/question.png"}
                                                                alt="example"
                                                                width="auto"
                                                                className="img-thumbnail"
                                                            />
                                                        </div>
                                                    </Colxx>
                                                </Row>
                                                <Row>
                                                    <Colxx xxs="12" className="mb-4">
                                                        <h2>Add Your First Set of Recommendation Questions</h2>
                                                        <p>Build a series of questions to help people filter the most relevant products & promotions for them</p>

                                                    </Colxx>
                                                </Row>
                                                <Row>
                                                    <Colxx xxs="12" className="mb-4">
                                                        <div
                                                            onClick={() => {
                                                                setIsAddQuestionSet(true);
                                                            }}
                                                        >
                                                            <Button
                                                                color="primary"
                                                                className="add-button"
                                                                style={{ width: '100%' }}
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} />
                                                                <span> </span>
                                                                Add Conversation Flow
                                                            </Button> </div>
                                                    </Colxx>
                                                </Row>
                                                <Collapse isOpen={isAddQuestionSet}>
                                                    <Colxx xxs="12" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
                                                        <QuestionSetForm CancelQuestionSet={CancelQuestionSet}
                                                            loadResponse={loadResponse}></QuestionSetForm>
                                                    </Colxx>
                                                </Collapse></CardBody>
                                        </Card>
                                    </Colxx>
                                    <Colxx xs="12" sm="4" md="4" lg="4" className="mb-4">
                                    </Colxx>
                                </Row>

                            </Fragment>
                        )}

                        {result !== null &&
                            <Fragment>
                                <ReactDragListView
                                    nodeSelector=".ant-list.draggable"
                                    lineClassName="dragLine"
                                    onDragEnd={(fromIndex, toIndex) =>
                                        onDragEnd(fromIndex, toIndex, "LIST-ITEM")
                                    }
                                >
                                    {result.map((set, index) => {
                                        return (
                                            <List key={index} className="draggable">
                                                <div className="d-flex flex-row" style={{ width: "100%" }}>
                                                    <span className="mr-1 draggable-span"><a href="#"><i className="simple-icon-menu"></i></a></span>
                                                    <QuestionSet set={set} index={index}
                                                        loadResponse={loadResponse}
                                                        setQCollasp={setCollasp}
                                                        collapseSet={collapseSet}
                                                        quesionSetsList={quesionSetsList}
                                                        roomTags={roomTags}
                                                        productTags={productTags}
                                                        formList={formList}
                                                        onDragEnd={onDragEnd}
                                                    />
                                                </div>
                                            </List>)
                                    })}
                                </ReactDragListView>
                            </Fragment>
                        }
                    </Colxx>
                    <Colxx xs="12" sm="12" md="3" lg="3" className="mb-4">
                        <div
                            className="content text-center" style={{ height: '100vh', position: 'fixed', overflow: 'auto' }} >
                            {((domains !== undefined && domains != null && typeof (domains) !== 'string' && domains.length > 0) &&
                                domains.filter((f) => f.type === 'BusinessOperator' ||
                                    f.type === 'UtilityProviders').length > 0) ?
                                <img
                                    src={Business_Operator_Recommender}
                                    alt="example"
                                    width="auto"
                                    className="img-thumbnail"
                                /> :
                                <img
                                    src={All_Recommender}
                                    alt="example"
                                    width="auto"
                                    className="img-thumbnail"
                                />
                            }
                        </div>
                    </Colxx>
                </Row>


            </Fragment>)
    }

    return (
        <Fragment>
            {isLoading ? (
                <Row>
                    <Colxx xxs="5" className="mb-2"></Colxx>
                    <Colxx xxs="2" className="mb-2">
                        <RotateSpinner size={60} color="#4556AC" loading={isLoading} />
                    </Colxx>
                    <Colxx xxs="5" className="mb-2"></Colxx>
                </Row>
            ) : (
                generator()
            )}
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale, domains, userName } = settings;
    return {
        propertyId,
        locale,
        domains,
        userName
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));